import services from 'services/module';
import {Strings} from 'Strings';

export class HttpSvc<T> {
    get: (config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;
    delete: (config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;
    post: (data?: any, config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;
    put: (data: any, config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;

    secureGet: (config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;
    secureDelete: (config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;
    securePost: (data?: any, config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;
    securePut: (data: any, config?: ng.IRequestShortcutConfig) => ng.IHttpPromise<T>;

    private url: string;
    private readonly path: string;
    private readonly headers: anm.Headers = {};

    private readonly methods         = ['get', 'post', 'put', 'delete'];
    private readonly methodsWithData = ['post', 'put'];

    constructor(private $http: ng.IHttpService, ...path: any[]) {
        this.path = path.join('/');
        this.url = options.apiDomain + '/' + this.path;

        this.createRegularMethods();
        this.createSecureMethods();
    }

    setApiUrl(url: string) {
        this.url = url + '/' + this.path;
        return this;
    }

    chain(path: any) {
        return new HttpSvc<T>(this.$http, this.path, path);
    }

    private withData(m: string): boolean {
        return _.contains(this.methodsWithData, m);
    }

    private setHeaders(method: string, headers: anm.Headers, params: Array<any>) {
        let [data = {}, config = {}] = params;
        if (!this.withData(method)) {
            config = data;
        }
        config.headers = _.extend(config.headers || {}, headers);
        return this.withData(method) ? [data, config] : [config];
    }

    private createRegularMethods() {
        _.each(this.methods, method => {
            this[method] = (...params: string[]) => {
                params = this.setHeaders(method, this.headers, params);
                return this.request(method, params);
            };
        });
    }

    private createSecureMethods() {
        _.each(this.methods, method => {
            const newMethod = 'secure' + Strings.capitalize(method);
            this[newMethod] = (...params: any[]) => {
                if (Strings.isBlank(options.headers['Animatron-Security-Token'])) {
                    if (console.trace) console.trace();
                    throw new Error('Empty cookie');
                }
                params = this.setHeaders(method, options.headers, params);
                return this[method](...params);
            };
        });
    }

    private request(methodName: string,
                    params: string[],
                    retry = true) {
        return this.$http[methodName](this.url, ...params).catch((reason: any) =>
            reason.status === -1 && retry ?
                this.request(methodName, params, false) : Promise.reject(reason)
        );
    }

}

export type HttpSvcFactory = <T>(...url: any[]) => HttpSvc<T>;

function HttpSvcFactory($http: ng.IHttpService) {
    return (...url: string[]) => new HttpSvc($http, ...url);
}

services.service('HttpSvc', HttpSvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/HttpSvc.ts